import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-oxygen-saturation-page',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './oxygen-saturation-page.component.html',
    styleUrl: './oxygen-saturation-page.component.css',
})
export default class OxygenSaturationPageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Saturazione di Ossigeno';
    chartLabel = 'Saturazione di Ossigeno';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'bar',
        [HealthChartPeriod.month]: 'bar',
    }
    heightHealthDataType = HealthDataType.OXYGEN_SATURATION;
    hasTwoDecimals = false;
    payloadTypes: dataType[] = ['daily', 'body', 'sleep'];

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
